/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pace_Est_DescInputs */

const en_ui_pace_est_desc = /** @type {(inputs: Ui_Pace_Est_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a recent race result to calculate your threshold pace using the Daniels VDOT formula.`)
};

const de_ui_pace_est_desc = /** @type {(inputs: Ui_Pace_Est_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib ein aktuelles Wettkampfergebnis ein — dein Schwellentempo wird mit der Daniels-VDOT-Formel berechnet.`)
};

/**
* | output |
* | --- |
* | "Enter a recent race result to calculate your threshold pace using the Daniels VDOT formula." |
*
* @param {Ui_Pace_Est_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_pace_est_desc = /** @type {((inputs?: Ui_Pace_Est_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pace_Est_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_pace_est_desc(inputs)
	return de_ui_pace_est_desc(inputs)
});